import {Box} from '@material-ui/core'
import Styled from 'src/components/Styled'
import styles from './styles'

export const Root = Styled(Box, styles.root)
export const FormContainer = Styled(Box, styles.formContainer)
